import { createFileRoute } from '@tanstack/react-router';
import { AffiliatesTab } from '../../pages/dashboard/affiliates/AffiliatesTab';

export const Route = createFileRoute('/dashboard/affiliates')({ component: AffiliatesTab });
